// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-consumption-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.account-consumption-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.account-consumption-page .header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.account-consumption-page .page-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.account-consumption-page .btn-back {
  padding: 0.5rem 1rem;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.account-consumption-page .btn-back:hover {
  background: #e0e0e0;
}

.account-consumption-page .error-message {
  background: #fee;
  color: #c00;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

/* Account Selector */
.account-selector-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.account-selector-section .form-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.account-selector-section label {
  font-weight: 500;
  color: #333;
}

.account-selector-section select {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  min-width: 250px;
}

/* Billing Section */
.billing-section {
  margin-bottom: 1.5rem;
}

.billing-section h2 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #333;
}

.billing-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.5rem;
}

.billing-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.billing-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.billing-label {
  font-weight: 500;
  color: #555;
}

.tariff-select {
  padding: 0.4rem 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}

.billing-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.billing-stat {
  text-align: center;
}

.billing-stat .stat-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.billing-stat .stat-label {
  display: block;
  font-size: 0.8rem;
  color: #888;
  margin-top: 0.25rem;
}

/* Tokens Card */
.tokens-card h3 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  color: #555;
}

.tokens-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.token-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.token-stat:last-child {
  border-bottom: none;
}

.token-stat .token-value {
  font-weight: 600;
  color: #333;
}

.token-stat .token-label {
  font-size: 0.85rem;
  color: #888;
}

/* Chart Section */
.chart-section {
  margin-bottom: 1.5rem;
}

/* Records Section */
.records-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.records-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.records-header h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-group label {
  font-size: 0.85rem;
  color: #666;
}

.filter-group select {
  padding: 0.4rem 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;
}

.records-table-container {
  overflow-x: auto;
}

.records-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
}

.records-table th,
.records-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.records-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #555;
  font-size: 0.85rem;
  white-space: nowrap;
}

.records-table .hash-cell {
  font-family: monospace;
  font-size: 0.8rem;
  color: #666;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.records-table .type-badge {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 500;
}

.records-table .type-badge.analysis {
  background: #d4edda;
  color: #155724;
}

.records-table .type-badge.operation {
  background: #e2e3e5;
  color: #383d41;
}

.records-table .empty-message {
  text-align: center;
  color: #888;
  padding: 2rem;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.pagination button {
  padding: 0.5rem 1rem;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination button:not(:disabled):hover {
  background: #e0e0e0;
}

.pagination span {
  font-size: 0.9rem;
  color: #666;
}

/* Responsive */
@media (max-width: 768px) {
  .account-consumption-page {
    padding: 1rem;
  }

  .billing-grid {
    grid-template-columns: 1fr;
  }

  .billing-stats {
    grid-template-columns: 1fr;
  }

  .account-consumption-page .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AccountConsumptionPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".account-consumption-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.account-consumption-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.account-consumption-page .header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.account-consumption-page .page-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.account-consumption-page .btn-back {\n  padding: 0.5rem 1rem;\n  background: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.account-consumption-page .btn-back:hover {\n  background: #e0e0e0;\n}\n\n.account-consumption-page .error-message {\n  background: #fee;\n  color: #c00;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n/* Account Selector */\n.account-selector-section {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1.5rem;\n}\n\n.account-selector-section .form-group {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.account-selector-section label {\n  font-weight: 500;\n  color: #333;\n}\n\n.account-selector-section select {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  min-width: 250px;\n}\n\n/* Billing Section */\n.billing-section {\n  margin-bottom: 1.5rem;\n}\n\n.billing-section h2 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.billing-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 1.5rem;\n}\n\n.billing-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.billing-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.billing-label {\n  font-weight: 500;\n  color: #555;\n}\n\n.tariff-select {\n  padding: 0.4rem 0.8rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.billing-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n\n.billing-stat {\n  text-align: center;\n}\n\n.billing-stat .stat-value {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.billing-stat .stat-label {\n  display: block;\n  font-size: 0.8rem;\n  color: #888;\n  margin-top: 0.25rem;\n}\n\n/* Tokens Card */\n.tokens-card h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  color: #555;\n}\n\n.tokens-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.token-stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #eee;\n}\n\n.token-stat:last-child {\n  border-bottom: none;\n}\n\n.token-stat .token-value {\n  font-weight: 600;\n  color: #333;\n}\n\n.token-stat .token-label {\n  font-size: 0.85rem;\n  color: #888;\n}\n\n/* Chart Section */\n.chart-section {\n  margin-bottom: 1.5rem;\n}\n\n/* Records Section */\n.records-section {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.records-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.records-header h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filter-group label {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.filter-group select {\n  padding: 0.4rem 0.8rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.85rem;\n}\n\n.records-table-container {\n  overflow-x: auto;\n}\n\n.records-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 700px;\n}\n\n.records-table th,\n.records-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.records-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #555;\n  font-size: 0.85rem;\n  white-space: nowrap;\n}\n\n.records-table .hash-cell {\n  font-family: monospace;\n  font-size: 0.8rem;\n  color: #666;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.records-table .type-badge {\n  display: inline-block;\n  padding: 0.2rem 0.6rem;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.records-table .type-badge.analysis {\n  background: #d4edda;\n  color: #155724;\n}\n\n.records-table .type-badge.operation {\n  background: #e2e3e5;\n  color: #383d41;\n}\n\n.records-table .empty-message {\n  text-align: center;\n  color: #888;\n  padding: 2rem;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n\n.pagination button {\n  padding: 0.5rem 1rem;\n  background: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination button:not(:disabled):hover {\n  background: #e0e0e0;\n}\n\n.pagination span {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .account-consumption-page {\n    padding: 1rem;\n  }\n\n  .billing-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .billing-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .account-consumption-page .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
